// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__AFrhk","box":"Projects_box__iA0Xo"};